import React from 'react';

import { Image } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionActionsPageData, usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';

export const HeroImage: React.FC = () => {
	const [{ shareSupporterVoiceSuccess }] = usePetitionActionsPageState();
	const {
		data: { petition },
	} = usePetitionActionsPageData();
	const { translate } = useI18n();
	const getStaticAssetUrl = useGetStaticAssetUrl();

	const imageUrl = petition.photo?.petitionLarge.url || getStaticAssetUrl('/images/default-petition-darker.gif');

	// The image is hidden after the initial step (sharing a text supporter voice).
	if (shareSupporterVoiceSuccess) {
		return null;
	}

	return (
		<Image
			data-testid="petition-image"
			src={imageUrl}
			alt={translate('corgi.petition_actions.image.alt_text')}
			// Absolutely-positioned so that the Header is overlaid.
			className="absolute inset-x-0 top-0 h-[215px] w-full rounded-none object-cover md:rounded-lg"
		/>
	);
};
